// Minimal changes for Vite compatibility

import { CurecallBanner } from '@honestica/curecall-ui'
import { useEffect, useState } from 'react'
import MedicalHeader from './medical-header.component'
import MedicalSidebar from './medical-sidebar.component'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { ModalsProvider } from 'src/providers/modals.provider'

export const MedicalLayout = () => {
  const { t } = useTranslation()
  const [isOnline, setIsOnline] = useState<boolean>(true)

  useEffect(() => {
    const isOnServerSideRendering = typeof window === 'undefined'
    if (isOnServerSideRendering) {
      return
    }
    setIsOnline(!!window.navigator.onLine)
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('offline', () => setIsOnline(false))
      window.addEventListener('online', () => setIsOnline(true))
    }
  })

  const handleBannerAction = () => {
    location.reload()
  }

  return (
    <>
      <MedicalSidebar />
      <div className="c-flex c-flex-col c-flex-grow c-max-h-full c-w-[calc(100vw-180px)]">
        <MedicalHeader />
        {!isOnline && (
          <CurecallBanner
            actionLabel={t('common.banners.clic-here-to-reload-the-page')}
            action={handleBannerAction}
          >
            {t('common.banners.sorry-connection-lost')}
          </CurecallBanner>
        )}
        <ModalsProvider>
          <main className="c-px-4 c-py-4 c-w-full [&>*]:c-w-full c-relative c-flex-grow c-flex c-overflow-y-scroll c-overflow-x-hidden">
            <Outlet />
          </main>
        </ModalsProvider>
      </div>
    </>
  )
}
